import { render, staticRenderFns } from "./DeviceVideo.vue?vue&type=template&id=ec82e094&scoped=true&"
import script from "./DeviceVideo.vue?vue&type=script&lang=js&"
export * from "./DeviceVideo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceVideo.vue?vue&type=style&index=0&id=ec82e094&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec82e094",
  null
  
)

export default component.exports